module.exports = __webpack_public_path__ + "media/images/consumer/signup/payment/credit-card/cvc-graphics@2x-cd6f0aed088a13c438e29c07c7914353.png";